import React from 'react';
import { StyledDialog } from './buyer-protection-dialog.style';

const BuyerProtectionDialog = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
    return (
        <StyledDialog isOpen={isOpen} onClose={onClose}>
            <h2>What is Buyer Protection?</h2>
            <p>
                Buyer Protection is automatically included when purchasing an item using the 'Buy
                Now' button. It offers:
            </p>
            <p>
                • A full refund of all fees and the item's price in the event of eligible order or
                item issues.
            </p>
            <p>• Secure payment processing, with funds held until delivery is confirmed.</p>
            <p>• Customer support to help resolve disputes.</p>
            <p>• Ongoing fraud prevention and risk monitoring.</p>
            {/* <LearnMoreButton
                label="Learn more"
                onClick={() => {
                    window.location.href = 'https://www.gumtree.com';
                }}
            /> */}
        </StyledDialog>
    );
};

export default BuyerProtectionDialog;
